import React from 'react';

import LandingSurfer from "../../images/surfer.jpg";
import PresentationImage from "../../images/presentation.png";

import "../../App.css";
import "./LandingPane.css";
import {Button, ThemeProvider} from "@mui/material";
import {AboutPacs} from "../../content/about/About";
import ImageTitleContent from "../../components/imagecontent/ImageTitleContent";
import {THEME} from "../../theme/PacsTheme";

export default function LandingPane(props) {

    const setSelected = props.setSelected;

    return (
        <React.Fragment>
            <div
                style={{
                    margin: "auto",
                    display: "inline-block",
                }}
            >
                <div
                    style={{
                        margin: "auto"
                    }}
                    className={"default-display-flex landing-pane-div"}
                >
                    <div
                        className=
                        {
                            "default-flex-size default-max-grow-50 default-align-center landing-background landing-header"
                        }
                    >
                        <div
                            style={{
                                fontFamily: "Courgette"
                            }}
                        >
                            Where Sun, Sand, and Surf meet Analytical Science
                        </div>
                        <div className={"default-margin-top-xlarge"}>
                            <ThemeProvider theme={THEME}>
                                <Button
                                    variant={"contained"}
                                    onClick={() => setSelected(1)}
                                >
                                    <span
                                        className={"default-font-bold default-font-xlarge"}
                                    >
                                        REGISTER NOW
                                    </span>
                                </Button>
                            </ThemeProvider>
                        </div>
                    </div>
                    <div className={"default-flex-size default-max-grow-50"}>
                        <img src={LandingSurfer} alt="LandingSurfer" width={"100%"} />
                    </div>
                </div>
                <div
                    // style={{
                    //     marginBottom: "50px",
                    //     display: "flex",
                    //     marginLeft: "auto",
                    //     marginRight: "auto",
                    // }}
                    className={
                        "default-margin-top-xlarge landing-pane-div-contained landing-pane-deadlines"
                    }

                >
                    <div className={"default-flex-size default-align-center"}>
                        <div
                            className={"landing-pane-alignment"}
                        >
                            {/*<div*/}
                            {/*    className={"landing-font-size-xlarge default-text-align-center default-font-bold"}*/}
                            {/*>*/}
                            {/*    <span style={{*/}
                            {/*        textDecoration: "underline"*/}
                            {/*    }}>Deadlines</span>*/}
                            {/*</div>*/}
                            {/*<div className={"default-text-align-center default-margin-top-medium default-font-xxlarge"}>Registration: 10/10/2025</div>*/}
                            {/*<div*/}
                            {/*    className={"landing-font-size-medium"}*/}
                            {/*>*/}
                            {/*    <div*/}
                            {/*        style={{*/}
                            {/*            border: "solid 2px white",*/}
                            {/*            marginTop: "20px",*/}
                            {/*            marginBottom: "20px",*/}
                            {/*            paddingBottom: "20px",*/}
                            {/*            borderRadius: "15px",*/}
                            {/*        }}*/}
                            {/*        className={"default-cursor-hover"}*/}
                            {/*        onClick={() => {setSelected(5)}}*/}
                            {/*    >*/}
                            {/*        <div*/}
                            {/*            className={"default-margin-top-medium default-text-align-center " +*/}
                            {/*                "default-font-xlarge default-font-bold"}*/}
                            {/*        >*/}
                            {/*            Abstract Submission (oral and poster)*/}
                            {/*        </div>*/}
                            {/*        <div*/}
                            {/*            className={"default-margin-top-medium default-text-align-center default-font-xlarge"}*/}
                            {/*        >*/}
                            {/*            <div>*/}
                            {/*                We've extended the deadline for poster and*/}
                            {/*                <span className={"default-font-bold"}>abstract submissions</span> for our upcoming conference! We understand that*/}
                            {/*                many of you are working hard to finalize your research, and we want to*/}
                            {/*                give you a bit more time.*/}
                            {/*            </div>*/}
                            {/*            <div className={"default-margin-top-medium"}>*/}
                            {/*                The new deadline for abstract submissions is:*/}
                            {/*                <span className={"default-font-bold default-font-xxlarge"}>&nbsp;&nbsp;&nbsp;10/10/25</span>*/}
                            {/*            </div>*/}
                            {/*            <div className={"default-margin-top-medium"}>*/}
                            {/*                <div>*/}
                            {/*                    This is a fantastic opportunity to share your work with a diverse community of experts and*/}
                            {/*                    peers. Don't miss your chance to be a part of the conversation and contribute to the success of*/}
                            {/*                    our event.*/}
                            {/*                </div>*/}
                            {/*                <div className={"default-margin-top-small"}>*/}
                            {/*                    We're putting together an incredible program filled with insightful*/}
                            {/*                    speakers and valuable networking opportunities.*/}
                            {/*                </div>*/}
                            {/*                <div className={"default-margin-top-small"}>*/}
                            {/*                    Stay tuned for more updates on our website.  We look forward to*/}
                            {/*                    receiving your submissions!*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    {/*<div*/}
                    {/*    className={"default-flex-size default-max-grow-40 landing-pane-padright"}*/}
                    {/*    style={{*/}
                    {/*        alignContent: "center"*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <img*/}
                    {/*        src={PresentationImage}*/}
                    {/*        alt="Presentation"*/}
                    {/*        width={"100%"}*/}
                    {/*        style={{*/}
                    {/*            borderRadius: "15px",*/}
                    {/*            maxWidth: "400px"*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
                <div
                    style={{
                        marginBottom: "20px"
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            paddingTop: "30px",
                            marginTop: "50px",
                            borderRadius: "25px",
                            marginLeft: "30px",
                            marginRight: "30px",
                            paddingBottom: "30px"
                        }}
                        className={"default-display-flex landing-pane-div"}>
                        <div
                            className={"default-display-flex"}
                        >
                            {
                                AboutPacs.map((pac, index) => {
                                    return <ImageTitleContent key={"ip_"+index} {...pac}/>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        backgroundImage: "url('background-wave.jpeg')",
                        backgroundRepeat: "no-repeat",
                        backgroundAttachment: "fixed",
                        backgroundSize: "cover",
                        maxWidth: "75%",
                        borderTop: "solid 1px white",
                        borderBottom: "solid 1px white",
                        margin: "auto",
                        marginBottom: "30px",
                        marginTop: "20px"
                    }}
                    className={"default-max-width"}
                >
                    <div
                        className={"landing-pane-feedback"}
                    >
                        Let Us Know How We Did!
                    </div>
                    <div
                        className={"landing-pane-feedback-2"}
                    >
                        We can't wait to see you next year...Let us know how to make at an even better experience!
                    </div>
                    <div
                        style={{
                            marginTop: "30px",
                            marginBottom: "30px",
                        }}
                    >
                        <ThemeProvider theme={THEME}>
                            <Button
                                variant={"contained"}
                                onClick={props.onFeedback}
                            >
                                    <span
                                        className={"default-font-bold default-font-xlarge"}
                                    >
                                        FEEDBACK
                                    </span>
                            </Button>
                        </ThemeProvider>
                    </div>
                </div>
                <div className={"default-font-bold"}>
                    This event is proudly sponsored by Neurocrine Biosciences
                </div>
            </div>
        </React.Fragment>
    )

}
